export default __webpack_public_path__ + "static/media/20210728_163102585_a2.a60b1daf.pdf";